module.exports = __webpack_public_path__ + "img/designBanner1.5f277195.jpg";